import { render, staticRenderFns } from "./DeviceTester.vue?vue&type=template&id=47bcb2ee&scoped=true"
import script from "./DeviceTester.vue?vue&type=script&lang=js"
export * from "./DeviceTester.vue?vue&type=script&lang=js"
import style0 from "./DeviceTester.vue?vue&type=style&index=0&id=47bcb2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bcb2ee",
  null
  
)

export default component.exports